// extracted by mini-css-extract-plugin
module.exports = {"c1xve3c2":"c1xve3c2","intro":"intro","h1fe6uox":"h1fe6uox"};